import WidgetStepPreview from '@/libs/widget-step-preview.common.js'
import '@/libs/widget-step-preview.css'

export default {
  name: "WidgetGallery",
  components: {
    WidgetStepPreview,
  },
  props: {
    templates: {
      type: Array,
      required: true,
    },
    hidePreview: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sortedTemplates() {
      return this.templates.slice().sort((a, b) => {
        // Get each priority; treat '', null, or 0 as "no priority" by setting to Infinity
        let aPriority = a.priority;
        let bPriority = b.priority;

        aPriority = (aPriority && aPriority !== 0 && aPriority !== '') ? aPriority : Infinity;
        bPriority = (bPriority && bPriority !== 0 && bPriority !== '') ? bPriority : Infinity;

        return aPriority - bPriority;
      });
    },
  },
  filters: {
    snakeToTitleCase(value) {
      if (!value) return "";
      return value
        .split("-")
        .map((item) => item.charAt(0).toUpperCase() + item.substring(1))
        .join(" ");
    },
  },
  methods: {
    triggerPreviewWidget(id) {
      this.$emit("preview-widget", id);
    },
  },
};
